module.exports = __webpack_public_path__ + "assets/img/teacher (20).0980bb71.png";